import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=4df4979b&scoped=true"
import script from "./AboutView.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AboutView.vue?vue&type=style&index=0&id=4df4979b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4979b",
  null
  
)

export default component.exports